import { type SxProps } from '@mui/system'

export const cardStyles: SxProps = {
  borderRadius: '12px',
  width: '100%'
}

export const accordionSummaryStyles: SxProps = {
  display: 'flex',
  alignItems: 'center'
}

export const stackSpacing: SxProps = {
  spacing: 2
}

export const textFieldStyles: SxProps = {
  marginBottom: '12px'
}

export const gridItemIconContainerStyles: SxProps = {
  display: 'flex',
  justifyContent: 'center',
  marginTop: '12px'
}

export const skeletonRectangularStyles: SxProps = {
  width: '95w',
  height: '6vh',
  marginBottom: '12px'
}
